import { endOfMonth, isAfter, now } from '@calendly/datetime'

export const nowIsAfterEndOfMonthForDate = (date) => (
  isAfter(now(), endOfMonth(date))
)
